import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-issue',
	path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
	exact: true,
};
